import { createI18n } from "vue-i18n";
import ja from "~/i18n/locales/ja.json";

export default defineNuxtPlugin((nuxtApp) => {
  const i18n = createI18n({
    legacy: false,
    locale: "ja",
    fallbackLocale: "ja",
    messages: {
      ja: {
        ...ja
      },
    },
  });

  nuxtApp.vueApp.use(i18n);

  const { t } = i18n.global;
  globalThis.$t = t;
});